import React, { useState, useRef } from "react";
import CmsMarkdown from "../../basic/cms-markdown";

import { IHeroVideoBg } from "../../../interfaces";
import CmsLink from "../../links/cms-link";
import SVG from "../../svg/component";

import {
  hero_video_container,
  video_wrapper,
  hero_content,
  bg_overlay,
  hero_content_inner,
  video_controls_button,
  video_controls
} from "./styles.module.scss";

const HeroVideoBg: React.FC<IHeroVideoBg> = ({ button, content, video_url, poster_image }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const handlePause = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
    if (isPlaying) {
      handlePause();
    } else {
      handlePlay();
    }
  };

  const posterImage = poster_image?.data?.attributes?.url;

  return (
    <div className={hero_video_container}>
      <div className={bg_overlay}></div>
      <div className={video_wrapper}>
        <video
          autoPlay
          muted
          loop
          playsInline
          aria-label="Background Video"
          ref={videoRef}
          onPlay={handlePlay}
          onPause={handlePause}
          poster={posterImage || ""}
        >
          <source src={video_url} type="video/mp4" />
        </video>
      </div>
      <div className={hero_content}>
        <div className={hero_content_inner}>
          <CmsMarkdown content={content} />
          <CmsLink link={button} classnames={["btn", "f3", "p-3"]} />
        </div>
      </div>
      <div className={video_controls}>
        <button className={video_controls_button} onClick={handlePlayPause}>
          {isPlaying ? <SVG name="pause" /> : <SVG name="play" />}
        </button>
      </div>
    </div>
  );
};

export default HeroVideoBg;
